import apiFetch from '../../apiFetch'

export default function (purchaseId, organizedUnitId, token) {
  return apiFetch({ endPoint: `dossier/purchase/${purchaseId}/SaleToVoCompany/${organizedUnitId}`, method: 'PUT', token: token })
}
